/**
* @version GENERATOR_VERSION::20200422
* @DateTime 2020-05-01T18:25:53.539
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	saveOrganizationManage,
	getOrganizationManageCreateInit,
	getOrganizationManageEditInit,
	getOrganizationManageView,
	deleteOrganizationManage
} from '@api/systemmanage/OrganizationManage';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

import {
listOrgPositionManageInit,
listOrgPositionManageByAuthorizations,
deleteOrgPositionManage
} from '@api/systemmanage/OrgPositionManage';

export default {
	namespaced: true,

	state: {
		CompoundEntityDictionary: cloneObj(RespCommonDef.CompoundEntityDictionary),
		CompoundEntityDictionaryAdd: cloneObj(RespCommonDef.CompoundEntityDictionary),
	},

	actions: {
		getOrganizationManageCreateInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				getOrganizationManageCreateInit({})
					.then(async res => {
						state.CompoundEntityDictionaryAdd = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getOrganizationManageEditInit({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getOrganizationManageEditInit({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},


		saveOrganizationManage({}, OrganizationManage) {
			return new Promise((resolve, reject) => {
				saveOrganizationManage(OrganizationManage)
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getOrganizationManageView({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getOrganizationManageView({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteOrganizationManage({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteOrganizationManage({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		}
	}
};
